<template>
  <div id="Main">Main View</div>
</template>

<script>
export default {
    name: 'Main',
    components: {},
    data: () => ({}),
    computed: {},
    methods: {},
    mounted() {}
};
</script>
